import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { UIProvider } from './contexts/UIContext'
import ErrorBoundary from './components/ErrorBoundary'
import ChunkErrorBoundary from './components/ChunkErrorBoundary'
import PWAPrompts from './components/PWAPrompts'
import { initSentry } from './utils/sentry'
import './index.css'

// Initialize error tracking before anything else can crash
initSentry();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* ErrorBoundary externo: pantalla de fallback genérica para
        errores no-chunk. ChunkErrorBoundary interno: intercepta los
        "Failed to fetch dynamically imported module" y dispara una
        recarga limpia (típico tras un deploy nuevo con hashes de
        chunks distintos al que el SW tiene cacheado). */}
    <ErrorBoundary>
      <ChunkErrorBoundary>
        <UIProvider>
          <App />
          <PWAPrompts />
        </UIProvider>
      </ChunkErrorBoundary>
    </ErrorBoundary>
  </React.StrictMode>,
)
